// extracted by mini-css-extract-plugin
export default {"container":"SuperAdminLayout_container__dv6hH","innerContainer":"SuperAdminLayout_innerContainer__0CzsP"};